type PartialPropertyRateTotals = Pick<App.PropertyRateTotals, 'displayPrice'>
type PartialPropertyRate = {
  totals: PartialPropertyRateTotals
  luxPlusTotals: PartialPropertyRateTotals | undefined
} | undefined
type PartialPricingWithValue = Pick<App.PricingWithValue, 'price'> | undefined

/**
 * @deprecated This will be inlined back into `<SinglePropertyHotelFlightsToggleButton/>` when we
 * discontinue the disabled variant of the `spp_use_accom_content` feature flag and get rid of the
 * deprecated prices.
 */
export function getSppPrices({
  hotelOnlyRate,
  hotelWithFlightsRate,
  pricing,
  memberPricing,
  pricingWithFlights,
  memberPricingWithFlights,
}: {
  hotelOnlyRate: PartialPropertyRate
  hotelWithFlightsRate: PartialPropertyRate
  pricing: PartialPricingWithValue
  memberPricing: PartialPricingWithValue
  pricingWithFlights: PartialPricingWithValue
  memberPricingWithFlights: PartialPricingWithValue
}): [number, number, number] {
  return [
    hotelOnlyRate?.totals.displayPrice ?? pricing?.price ?? 0,
    hotelOnlyRate?.luxPlusTotals?.displayPrice ?? memberPricing?.price ?? 0,
    hotelWithFlightsRate?.luxPlusTotals?.displayPrice ?? hotelWithFlightsRate?.totals.displayPrice ?? memberPricingWithFlights?.price ?? pricingWithFlights?.price ?? 0,
  ]
}
